export enum PanelType {
    Dashboard,
    Timeline,
    ContentEditor,
    DevicePanel,
    BrowserPanel,
    Notepad,
    Mixer,
    Modulation,
    ModularSystem,
    MidiFall,
    ProjectInfo,
    ShadertoyPreview,
    ShadertoyEditor,
    CodeEditor,
    EmptyFlexSpace,
    TapTempo,
    Analysis
}